import React, {useState} from 'react';

const SwivuWelcomeModal = ({
  isDisplayCheck = true,
  onContinueBoard,
  className = "mt-4",
  btnText = "Continue To Board"
}) => {
  const [isDontShowAgainChecked, setIsDontShowAgainChecked] = useState(false);

  return (
    <div className="flex flex-col items-center mt-2">
      { isDisplayCheck && <div className={`flex items-center mb-4 ${className}`}>
        <input
          id="link-checkbox"
          type="checkbox"
          defaultValue=""
          onClick={(e) => setIsDontShowAgainChecked(e.target.checked)}
          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
        />
        <label
          htmlFor="link-checkbox"
          className="ms-2 text-md font-medium text-gray-900 dark:text-gray-300"
        >
          Got it. Please don't show me this again.
        </label>
      </div> }
      <button
        className="border-2 border-solid border-[#464d5a] cursor-pointer bg-transparent px-2.5 py-2.5 rounded-md font-normal text-base text-black dark:text-white mb-[25px]"
        onClick={() => onContinueBoard(isDontShowAgainChecked)}
      >
        {btnText}
      </button>
    </div>
  );
};


export default SwivuWelcomeModal;